
import * as React from 'react'
import { Image, Text, View, TouchableOpacity, ActivityIndicator } from 'react-native'
import images from '../../assets/images'
import { useTheme, useNavigation } from '@react-navigation/native'
import moment from 'moment'
import Axios from 'axios'
import { FlatList } from 'react-native'
import { AntDesign } from '@expo/vector-icons'
import qs from 'qs'

export default function FinanceDate({ day_string, filters }) {
    const { colors } = useTheme()
    const navigation = useNavigation()
    const [data, setData] = React.useState()
    const [refreshing, setRefreshing] = React.useState(true)
    const image_seat = <Image source={images.icons.icon_seat_2} style={{ width: 20, height: 20, resizeMode: 'contain', marginLeft: 8 }} />
    const image_coint = <Image source={images.icons.icon_coin} style={{ width: 20, height: 20, resizeMode: 'contain', marginLeft: 8 }} />

    React.useEffect(() => {
        setRefreshing(true)
        let query = {
            day: moment(day_string, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            chieu: filters?.directions ? filters?.directions : [],
            product: filters?.products ? filters?.directions : [],
            route: filters?.routes ? filters?.routes : []
        }
        Axios.get(`/api/ceo/fill_factor?${qs.stringify(query)}`)
            .then(res => {
                console.log(res)
                if (res.status === 200 && res.data.data)
                    setData(res.data.data)
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }, [day_string, filters])

    const onRefresh = () => {
        setRefreshing(true)
        let query = {
            day: moment(day_string, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            chieu: filters?.directions ? filters?.directions : [],
            product: filters?.products ? filters?.directions : [],
            route: filters?.routes ? filters?.routes : []
        }
        Axios.get(`/api/ceo/fill_factor?${qs.stringify(query)}`)
            .then(res => {
                console.log(res)
                if (res.status === 200 && res.data.data) {
                    setData(res.data.data)
                }
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }

    const getColorProgress = (value) => {
        try {
            if (value < 50) return colors.process_3
            else if (value < 75) return colors.process_1
            else return colors.process_2
        } catch (error) {
        }
    }

    if (refreshing) {
        return <ActivityIndicator style={{ marginTop: 24 }} size="small" color={colors.text} />
    }

    return (
        <View style={{ flex: 1 }}>
            {
                data ? <>
                    <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginVertical: 8 }}>
                        <Text style={{ color: colors.text, fontSize: 14, fontFamily: 'Nunito_700Bold', paddingHorizontal: 12, flex: 1 }}>Danh sách chuyến đi</Text>
                        <TouchableOpacity onPress={() => navigation.navigate('ModalFilter', { filters: filters })} style={{ flexDirection: 'row', alignItems: 'center', paddingRight: 12 }}>
                            <Text style={{ color: colors.text, fontSize: 14, fontFamily: 'Nunito_700Bold', marginRight: 3 }}>Bộ lọc</Text>
                            <AntDesign name="filter" size={16} color={colors.text} />
                        </TouchableOpacity>
                    </View>
                    <FlatList
                        data={data}
                        keyExtractor={item => `${item.id}`}
                        renderItem={({ item }) => <View style={{
                            backgroundColor: 'white', borderRadius: 10, marginHorizontal: 12, marginVertical: 8,
                            paddingVertical: 8, paddingHorizontal: 5, flexDirection: 'row'
                        }}>
                            <View style={{ flexDirection: 'column', flex: 1 }}>
                                <View style={{ backgroundColor: '#A7A8CD', borderRadius: 5, alignSelf: 'flex-start' }}>
                                    <Text style={{
                                        paddingHorizontal: 10, paddingVertical: 2, fontSize: 14, fontFamily: 'Nunito_700Bold', color: 'white'
                                    }}>{item.time_start} - {item.node_side}</Text>
                                </View>
                                <View style={{ paddingLeft: 10 }}>
                                    <Text style={{ color: colors.text, fontSize: 14, fontFamily: 'Nunito_700Bold', marginTop: 4 }}>{item.vehicle_bks}</Text>
                                    <Text style={{ color: colors.text, fontSize: 14, fontFamily: 'Nunito_400Regular' }}>{item.route_code}</Text>
                                    <Text style={{ color: colors.text, fontSize: 14, fontFamily: 'Nunito_700Bold' }}>{item.product_name}</Text>
                                </View>
                            </View>
                            <View style={{ flexDirection: 'column', justifyContent: 'center', flex: 1 }}>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <View style={{
                                        height: 25, position: 'relative', backgroundColor: colors.process_background, borderRadius: 3,
                                        justifyContent: 'center', flex: 1
                                    }}>
                                        <View style={{
                                            position: 'absolute', top: 0, left: 0, width: `${item.percent_customer > 100 ? 100 : item.percent_customer}%`,
                                            height: '100%', backgroundColor: getColorProgress(item.percent_customer), borderRadius: 3
                                        }} />
                                        <View style={{
                                            position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                                            alignItems: 'center', paddingHorizontal: 6, flexDirection: 'row'
                                        }}>
                                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', flex: 1 }}>{item.fill_factor_customer}</Text>
                                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{item.percent_customer}%</Text>
                                        </View>
                                    </View>
                                    {image_seat}
                                </View>
                                <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 16 }}>
                                    <View style={{
                                        height: 25, position: 'relative', backgroundColor: colors.process_background, borderRadius: 3,
                                        justifyContent: 'center', flex: 1
                                    }}>
                                        <View style={{
                                            position: 'absolute', top: 0, left: 0, width: `${item.percent_revenue > 100 ? 100 : item.percent_revenue}%`,
                                            height: '100%', backgroundColor: getColorProgress(item.percent_revenue), borderRadius: 3
                                        }} />
                                        <View style={{
                                            position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                                            alignItems: 'center', paddingHorizontal: 6, flexDirection: 'row'
                                        }}>
                                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', flex: 1 }}>{item.fill_factor_revenue}</Text>
                                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{item.percent_revenue}%</Text>
                                        </View>
                                    </View>
                                    {image_coint}
                                </View>
                            </View>
                        </View>
                        }
                    />
                </> : (
                        !refreshing ? <View style={{ marginTop: 80, flexDirection: 'column', alignItems: 'center' }}>
                            <Image source={images.server_error} style={{ width: 200, height: 200 }} />
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', marginTop: 24, fontSize: 18 }}>Đã có lỗi xảy ra</Text>
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>Vui lòng ấn nút bên dưới để thử lại</Text>
                            <TouchableOpacity onPress={onRefresh}>
                                <Image source={images.refresh} style={{ width: 40, height: 40, marginTop: 16 }} />
                            </TouchableOpacity>
                        </View> : null
                    )
            }
        </View>
    );
}